var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import * as ReactDOM from "react-dom";
import { IdDomElement } from "../../constants/IdDomElement";
var TooltipModal = /** @class */ (function (_super) {
    __extends(TooltipModal, _super);
    function TooltipModal(props) {
        var _this = _super.call(this, props) || this;
        _this.el = document.createElement("div");
        _this.modalRoot = document.getElementById(IdDomElement.PortalRoot);
        return _this;
    }
    TooltipModal.prototype.componentDidMount = function () {
        // swap for replaceChild?
        this.modalRoot.appendChild(this.el);
    };
    TooltipModal.prototype.componentWillUnmount = function () {
        this.modalRoot.removeChild(this.el);
    };
    TooltipModal.prototype.render = function () {
        return ReactDOM.createPortal(React.createElement("div", { className: this.props.className }, this.props.children), this.el);
    };
    return TooltipModal;
}(React.Component));
export { TooltipModal };



//////////////////
// WEBPACK FOOTER
// ./src/features/tooltip/TooltipModal.tsx
// module id = 664
// module chunks = 3